import {BackendResponse} from '@common/http/backend-response/backend-response';
import {useMutation} from '@tanstack/react-query';
import {apiClient, queryClient} from '@common/http/query-client';
import {showHttpErrorToast} from '@common/http/show-http-error-toast';
import {UseFormReturn} from 'react-hook-form';
import {onFormQueryError} from '@common/errors/on-form-query-error';
import {RequestTitle} from '@app/titles/models/Request';

interface Response extends BackendResponse {
  request: Request;
}

export interface CreateRequestPayload extends RequestTitle {}
export function useCreateRequest(form: UseFormReturn<CreateRequestPayload>) {
  return useMutation({
    mutationFn: (payload: CreateRequestPayload) => createRequest(payload),
    onSuccess: async () => {
      await queryClient.invalidateQueries({queryKey: ['requests']});
    },
    onError: r => (form ? onFormQueryError(r, form) : showHttpErrorToast(r)),
  });
}

function createRequest(payload: CreateRequestPayload): Promise<Response> {
  return apiClient.post(`requests`, payload).then(r => r.data);
}
